import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { ScreenService } from 'core/services';
import { DeleteAccountCompletePresenter } from './presenter';

export const DeleteAccountComplete: React.VFC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>
          {ScreenService.getDocumentTitle(
            t('ui.pages.DeleteAccountComplete.title'),
          )}
        </title>
      </Helmet>
      <DeleteAccountCompletePresenter />
    </>
  );
};
